module.exports = __webpack_public_path__ + "img/sp_3.2d2cafd6.png";